import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

function initBlock() {

  if(!('.block-ecommerce-header').length) { return false }

  let timeline = gsap.timeline({
      scrollTrigger: {
        trigger: '.block-ecommerce-header .block-col-right',
        start: 'top 15%',
        end: '40% top',
        scrub: 0.05,
        //markers: true,
        //toggleActions: 'resume pause reverse pause'
      }
    }
  )

  //timeline.fromTo('.block-ecommerce-header .video-file-container ', { y: 0 }, { y: 100, duration: 1 }, 0)
  timeline.fromTo('.block-ecommerce-header .video-fade-3', { y: 0 }, { y: 30, duration: 1, ease: 'none' }, 0)
  timeline.fromTo('.block-ecommerce-header .video-fade-2', { y: 0 }, { y: 50, duration: 1, ease: 'none' }, 0)
  timeline.fromTo('.block-ecommerce-header .video-fade-1', { y: 0 }, { y: 70, duration: 1, ease: 'none' }, 0)

  $('body').on('click', '.apply-to-footer-form', function (e) {
    e.preventDefault()

    let apply = document.getElementById("apply-now-form");
    apply.scrollIntoView({behavior: 'smooth'}, true);
  })

}




initBlock()
